// gallery_layout: thumbnail_slider はPC(750px以上)でメイン画像を横スクロールではなく
// display:none の切り替えで表示しており、Dawn標準のスライダー矢印（スクロール前提）では
// 何も起きない。そのため矢印クリック時に対応するサムネイルボタンをクリックさせて
// 既存の切り替えロジック（media-gallery.js の setActiveMedia）を流用する。
(function () {
  var desktopQuery = window.matchMedia('(min-width: 750px)');

  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    var buttons = viewer && viewer.querySelector('.subu-product-gallery-buttons');
    if (!viewer || !thumbnails || !buttons) return;

    var prevButton = buttons.querySelector('.slider-button--prev');
    var nextButton = buttons.querySelector('.slider-button--next');

    function goToStep(step) {
      // '[data-media-id]' だとスライドli内部のズームボタン等（section.idを含まないdata-media-id）も
      // 一緒に拾ってしまい順番がずれるため、スライドliのみに絞る（SliderComponent自身と同じ条件）
      var items = Array.prototype.slice.call(viewer.querySelectorAll('[id^="Slide-"]'));
      var currentIndex = items.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
      if (currentIndex === -1) return;
      var nextItem = items[(currentIndex + step + items.length) % items.length];
      var thumbnailButton = thumbnails.querySelector(
        '[data-target="' + nextItem.dataset.mediaId + '"] button'
      );
      if (thumbnailButton) thumbnailButton.click();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        if (!desktopQuery.matches) return;
        goToStep(-1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        if (!desktopQuery.matches) return;
        goToStep(1);
      });
    }
  });
})();
